import React, { useState } from "react";
import "./form6.css";
import { useNavigate } from 'react-router-dom';

const Form6 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, formData);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.planet) newErrors.planet = "required";
    if (!formData.Year) newErrors.Year = "required";
    if (!formData.Month) newErrors.Month = "required";
    if (!formData.Day) newErrors.Day = "required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validate()) {
      //   alert("Form submitted successfully");
      //   navigate("/");
      navigate(setStep(7));
    }
  };

  const handleBack = () => {
    setStep(5);
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1950 + 1 },
    (_, i) => currentYear - i
  );
  const months = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const dates = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

  return (
    <div className="form6-background">
      <div className="form6-section">
        <h2 className="form6-title">Dhisai Iruppu(6/7)</h2>
        <form>
          <div className="form6-row">
            <div className="form6-group">
              <label>Planet <span className="error fs-star">*</span></label>
              <select name="planet" value={formData.planet} onChange={handleChange}>
                <option value="">Choose a Planet</option>
                <option value="லக்னம்">Lagna</option>
                <option value="சூரியன்">Sun</option>
                <option value="சந்திரன்">Moon</option>
                <option value="செவ்வாய்">Mars</option>
                <option value="புதன்">Mercury</option>
                <option value="குரு">Jupiter</option>
                <option value="சுக்ரன்">Venus</option>
                <option value="சனி">Saturn</option>
                <option value="ராகு">Rahu</option>
                <option value="கேது">Kethu</option>
              </select>
              {errors.planet && <span className="error-text">{errors.planet}</span>}
            </div>

            <div className="form6-group">
              <label>Year <span className="error fs-star">*</span></label>
              <input type="text" className="form-control" name="Year" value={formData.Year} onChange={handleChange} />

              {errors.Year && <span className="error-text">{errors.Year}</span>}
            </div>

            <div className="form6-group">
              <label>Month <span className="error fs-star">*</span></label>
                        <input type="text" className="form-control" name="Month" value={formData.Month} onChange={handleChange} />

              {errors.Month && <span className="error-text">{errors.Month}</span>}
            </div>

            <div className="form6-group">
              <label>Days<span className="error fs-star">*</span></label>
                       <input type="text" className="form-control" name="Day" value={formData.Day} onChange={handleChange} />

              {errors.Day && <span className="error-text">{errors.Day}</span>}
            </div>
          </div>

          <div className="form6-btn-group">
            <button type="button" className="back-btn-5" onClick={handleBack}>Back</button>
            <button type="button" onClick={handleNext} className="submit-btn-5">Continue</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form6;
